// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__LC_Mp","ranges":"BmiRanges_ranges__1ZrTn"};